// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2088":"d77a4961","2292":"a05a0da9","2374":"9c240dbe","3295":"06b87569","6540":"a05a0da9","6652":"a05a0da9","7832":"a05a0da9","9008":"61d6daca","9136":"a05a0da9"}[chunkId] + ".chunk.css";
};